import React, { useEffect, useRef, useState } from "react";
import { Alert, Backdrop, Box, CircularProgress, Fade, TextField, Button, FormControl, InputLabel, Select, OutlinedInput, MenuItem, FormControlLabel, Checkbox, Typography, Chip, IconButton, Modal } from '@mui/material';
import { getAllUsersForTasks } from "../../../../../../services/UserService";
import { formatCvCandidat } from "../../../../../../services/CandidatService";
import {
  revealProcess,
  sendProcess,
} from "../../../../../../services/ProcessService";
import { getUserData, capitalise } from "../../../../../../utils/FunctionHelpers";
import { FiSend } from "react-icons/fi";
import { useParams } from "react-router-dom";
import moment from "moment";
import { getDetails } from "../../../../../../services/UserService";
import TagsInput from "../../../../../../utils/TagsInput";
import { withSnackbar } from "../../../../../../utils/SnackbarHOC";
import EditorCustom from "../../../../../../components/EditorCustorm/EditorCustom";
import AttachFile from '@mui/icons-material/AttachFile';
import { v4 } from "uuid";


const paperStyle = {
  zIndex: 1,
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px',
  borderRadius: '16px',
  width: '50em',
  maxWidth: '95vw',
  outline: 'none',
};

const SendCandidatToClientModal = ({
                                     reloadData,
                                     setReloadData,
                                     candidatName,
                                     missions,
                                     selectedMission,
                                     sentDate,
                                     forReveal,
                                     isMissionActive,
                                     candidatEmail,
                                     candidatTel,
                                     revealDate,
                                     candidatSeniorite,
                                     candidatCommentaire,
                                     candidatPointFort,
                                     candidatSoftskills,
                                     candidatFrancais,
                                     candidatAnglais,
                                     candidatActuPackage,
                                     candidatActuFixe,
                                     candidatActuVariable,
                                     candidatActuInteress,
                                     candidatSouhaitePackage,
                                     candidatsouhaiteFixe,
                                     candidatsouhaiteVariable,
                                     candidatpreAvis,
                                     candidatdispoLe,
                                     numCandidat,
                                     processId,
                                     disabled,
                                     snackbarShowMessage
                                   }) => {
  const [uniqueMissions, setUniqueMissions] = useState(missions);
  const [displayPhoneNumber, setDisplayPhoneNumber] = useState(true);
  const mission = uniqueMissions.filter((m) => m.missionId === selectedMission)[0];
  const { idCandidat } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [missingFormattedCv, setMissingFormattedCv] = useState(false);
  const [formattingCv, setFormattingCv] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [errors, setErrors] = useState({});
  const [de, setDe] = useState(getUserData().uuid);
  const [cc, setCc] = useState([]);
  const [cci, setCci] = useState([]);
  const [autresPieces, setAutresPieces] = useState([]);
  const [NomUser, setNomUser] = useState(getUserData()?.firstname);
  const [PrenomUser, setPrenomUser] = useState(getUserData()?.lastname);
  const [EmailUser, setEmailUser] = useState(getUserData().email);
  const [FunctionUser, setFunctionUser] = useState(getUserData().fonction);
  const [checked, setChecked] = useState(0);
  const formRef = useRef(null)
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([selectedMission]);
  const [dataUpload, setDataUpload] = useState([]);
  const uploadRef = useRef(null);


  const languagesSection = `
  ${(candidatFrancais == null && candidatAnglais == null) ||
  (candidatAnglais === 'null' && candidatFrancais === 'null') ? "" : "<b>LANGUES : </b><br>"}
  
   ${candidatAnglais === null || candidatAnglais === 'null' ? "" :  "<b>  Anglais : </b> " + candidatAnglais}<br>
   ${candidatFrancais === null || candidatFrancais === 'null' || candidatFrancais === undefined || candidatFrancais === "" ? "" : "<b>  Francais : </b> " + candidatFrancais}<br>
`;

  const availabilitySection = `
  ${candidatpreAvis && candidatpreAvis !== 'null' ? "<strong>DISPONIBILITE : </strong>" + candidatpreAvis : ""}
`;

  const availabilityDateSection = `
  ${![null, "", "null"].includes(candidatdispoLe) ? "<strong>Disponible le : </strong>" + moment(candidatdispoLe).format("DD/MM/yyyy") : ""}
`;

  const sendMessage = `   
  Bonjour ${uniqueMissions.filter((m) => selected.includes(m.missionId)).map((mission) => capitalise(mission.destinatairePrincipale?.split(' ')[0]))?.join(', ')?.toString()},
  <p>Ci-joint un dossier qui correspond à votre demande ainsi que la synthèse de nos échanges.</p>
  
  ${candidatSeniorite && candidatSeniorite !== 'null' ? "<b>SENIORITE : </b>" + candidatSeniorite + " ans<br/>" : ""}
  
  ${candidatPointFort && decodeHtml(candidatPointFort).trim() !== '' && decodeHtml(candidatPointFort) !== 'null' ? "<b>POINTS FORTS : </b>" + candidatPointFort + "<br/>" : ""}
  
  ${candidatSoftskills && decodeHtml(candidatSoftskills).trim() !== '' && decodeHtml(candidatSoftskills) !== 'null' ? "<b>SOFT SKILLS : </b>" + candidatSoftskills + "<br/>" : ""}
  
  ${candidatCommentaire && decodeHtml(candidatCommentaire).trim() !== '' && decodeHtml(candidatCommentaire) !== 'null' ? "<b>COMMENTAIRES : </b>" + candidatCommentaire + "<br/>" : ""}
  
  ${languagesSection}
  ${availabilitySection}
  ${availabilityDateSection}
  
  <br><p>Si vous souhaitez organiser une rencontre, merci de nous l'indiquer par retour de mail.</p>
  Bonne réception,
`;
  const firstRevealMessage = `Bonjour ${uniqueMissions.filter((m) => selected.includes(m.missionId)).map((mission) => capitalise(mission.destinatairePrincipale?.split(' ')[0]))?.join(', ')?.toString()}, <p/>
Comme convenu, veuillez trouver ci-dessous les coordonnées du dossier N° ${numCandidat} : <p/>
<b>${candidatName}</b><p/>
Mobile : <b>${candidatTel ?? "-"}</b><p/>
Email : <b>${candidatEmail ?? "-"}</b><p/>
Nous venons de l'appeler et lui avons fait part de la bonne nouvelle ainsi que de votre appel imminent. Nous comptons sur votre réactivité pour maintenir son niveau de motivation.<p/>
Merci de nous tenir informés de la date d'entretien convenue pour vous accompagner au mieux.<p/>
Bonne réception,`

  const secondRevealMessage = `Bonjour ${uniqueMissions.filter((m) => selected.includes(m.missionId)).map((mission) => capitalise(mission.destinatairePrincipale?.split(' ')[0]))?.join(', ')?.toString()},<p/>
  Nous nous permettons de vous renvoyer les coordonnées de ce dossier comme déjà transmises, à votre demande le ${sentDate}.
Sauf erreur de notre part, la personne en question n'a toujours pas été contactée par vos services.<p/>
Pour mémoire, nous avons reçu cette personne en entretien, lui avons présenté votre entreprise et informé que souhaitiez la rencontrer. 
Elle est donc à ce jour en attente de votre prise de contact et nous relance.<p/>
Si vous n'êtes plus intéressés par ce dossier merci de nous le signifier par retour de mail.<p/>
Sans retour de votre part sous une semaine nous lui signifierons que sa candidature a finalement été refusée par votre société.<p/>
Comme convenu, veuillez trouver à nouveau ci-dessous ses coordonnées :<p/>
<b>${candidatName}</b></br>
${[null, 'undefined', " "].includes(candidatTel) ? "" : (" <b>Tel  </b> : " + candidatTel)}<p/>
${[null, 'undefined', '', " "].includes(candidatEmail) ? "" : (" <b>Email  </b> : " + candidatEmail)}<p/>
Merci de nous tenir informés de votre retour.<p/>
Cordialement,`;

  const [objet, setObjet] = useState(
      forReveal
          ? `GO&DEV - Coordonnées de ${candidatName} - Dossier Nº ${numCandidat} `
          : `GO&DEV - Dossier Nº ${numCandidat} - ${candidatName} : ${mission.nom_mission}`
  );

  useEffect(() => {
    setMessage(handleInitiateMessage)
  }, [selected])

  const handleInitiateMessage = () => {
    if (forReveal && revealDate === 'Révéler') {
      return firstRevealMessage
    }
    if (forReveal && revealDate !== 'Révéler') {
      return secondRevealMessage
    }
    return sendMessage
  }

  const [message, setMessage] = useState(handleInitiateMessage());

  const handleSignature = async (id) => {
    setDe(id);
    getDetails(id)
  };
  function decodeHtml(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }
  const isAllSelected =
      uniqueMissions.length > 0 && selected.length === uniqueMissions.length;
  const isIndeterminate =
      uniqueMissions.length > 0 &&
      selected.length > 0 &&
      selected.length !== uniqueMissions.length;
  const validate = () => {
    let temp = {};
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleOpen = () => {
    if (disabled) return;
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  const handlecheckChange = (e) => {
    setChecked(e.target.checked ? 1 : 0);
  };

  const handleSelectedCC = (ccs) => {
    setCc(ccs);
  }

  const handleSelectedCCI = (ccis) => {
    setCci(ccis);
  }

  // Sending to a client attaches the Go&Dev formatted CV: when it is missing the
  // backend refuses, so the modal offers to generate it right here.
  const isMissingFormattedCvError = (msg) => /CV Format/i.test(msg || '');

  const handleFormatCv = async () => {
    if (formattingCv) return;
    setFormattingCv(true);
    try {
      await formatCvCandidat(idCandidat);
      setMissingFormattedCv(false);
      snackbarShowMessage("CV formaté généré. Vous pouvez envoyer le mail.", "success", 5000);
    } catch (error) {
      snackbarShowMessage(error.response?.data?.error || error.response?.data?.error?.detail || "Erreur lors de la génération du CV formaté", "error", 5000);
    } finally {
      setFormattingCv(false);
    }
  };

  const handleSend = async () => {
    if (loading) return; // no double send
    try {
      if (validate()) {
        setLoading(true);
        let selectedMissions = [];
        selected.forEach(element => {
          selectedMissions.push(forReveal ? selectedMission : element)
        });

        const formData = new FormData();
        formData.append('autresPieces', autresPieces);
        formData.append('de', de);
        formData.append('cc', cc);
        formData.append('cci', cci);
        formData.append('objet', objet);
        formData.append('processId', processId);
        formData.append('dateIntegration', null);
        formData.append('date', moment(new Date()).format());
        formData.append('message', message );
        formData.append('candidat', idCandidat);
        dataUpload.map((file, index) => formData.append(`pj[${index}]`, file))
        formData.append("displayPhoneNumber", displayPhoneNumber);

        selectedMissions.forEach((mission, index) => {
          formData.append(`selected[${index}]`, mission);
        });
        formData.append('stats', checked);
        const endpoint = forReveal ? revealProcess : sendProcess;
        await endpoint(formData);
        snackbarShowMessage("Email envoyé.", "success", 4000);
        setReloadData(!reloadData);
        handleClose();
      }
    } catch (error) {
      const detail = error.response?.data?.error?.detail || error.message;
      if (isMissingFormattedCvError(detail)) setMissingFormattedCv(true);
      snackbarShowMessage(detail, "error", 5000);
    } finally {
      setLoading(false);
    }
  };



  React.useEffect(() => {
    let active = true;
    if (openModal) {
      (async () => {
        setLoadingUsers(true);
        try {
          const users = await getAllUsersForTasks();
          if (!active) {
            return;
          }
          setUsers(users.data);
          setLoadingUsers(false);
        } catch (error) {
          if (!active) {
            return;
          }
          snackbarShowMessage(error.response.data.error.detail, "error", 4000);
          setLoadingUsers(false);
        }
      })();
    }

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (value === "all") {
      setSelected(
          selected.length === uniqueMissions.length
              ? []
              : uniqueMissions.map((mission) => {
                return mission.missionId;
              })
      );
      return;
    }
    if (selected.indexOf(value) !== -1) {
      // if value already present
      const newSelected = selected.filter((s) => s !== value);
      setSelected(newSelected);
    } else {
      // if value not present
      setSelected([...selected, value])
    }
  };

  useEffect(()=> {
    let result = missions.filter((item, index, self) =>
        index === self.findIndex((t) => t.missionId === item.missionId)
    );
    setUniqueMissions(result);
  }, [missions]);

  const listItem = uniqueMissions.map((mission) => {
    return (
        mission.missionId == selectedMission &&
        (<div key={mission.missionId}>
          <FormControlLabel
              label={
                  mission.nom_societe?.toUpperCase() + " : " + mission.nom_mission
              }
              control={
                <Checkbox
                    value={mission.missionId}
                    checked={selected.includes(mission.missionId)}
                    onChange={handleChange}
                />
              }
          />
          <Typography style={{ marginLeft: "34px" }}>
            A : {mission.destinatairePrincipale + ", " + mission.EmailDestinatairePrincipale}
          </Typography>

          <Typography style={{ marginLeft: "34px" }}>
            {mission.secondaires.length > 0 ? "CC : " : "C : -"}
            {mission.secondaires.map((secondaire, index) => {
              return (
                  <span key={`cc_${index}`}>
                <span style={{ textTransform: "capitalize" }}>
                  {(index ? ", " : "") + secondaire.prenom}
                </span>
                <span style={{ textTransform: "uppercase" }}>
                  {" " + secondaire.nom}
                </span>
              </span>
              );
            })}
          </Typography>
        </div>)
    );
  });

  const PourMission = () => {
    const mission = uniqueMissions.filter((m) => m.missionId === selectedMission)[0];
    return (
        <div style={{ margin: "10px 0px" }}>
          <Typography>
            Pour Mission :{" "}
            {mission.nom_mission + " - société : " + mission.nom_societe}
          </Typography>
          <Typography component={"span"}>{"A : "}</Typography>
          <Typography component="span">
            {mission.destinatairePrincipale.charAt(0)?.toUpperCase() +
                mission.destinatairePrincipale.slice(1) + ", " + mission.EmailDestinatairePrincipale}
          </Typography>
          <Typography>
            {mission.secondaires.length > 0 ? "CC : " : "C : -"}
            {mission.secondaires.map((secondaire, index) => {
              return (
                  <span key={`cc_${index}`}>
                <span style={{ textTransform: "capitalize" }}>
                  {(index ? ", " : "") + secondaire.prenom}
                </span>
                <span style={{ textTransform: "uppercase" }}>
                  {" " + secondaire.nom}
                </span>{" "}
              </span>
              );
            })}
          </Typography>
        </div>
    );
  };

  const clearFieds = () => {
    setMessage("");
    setObjet(null);
    setCc([]);
    setCci([]);
    setDataUpload([])

  };

  React.useLayoutEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0
    }
  }, [formRef.current]);

  const editorCustomProps = {
    value: message,
    setValue: setMessage,
    enableOnBlur: false
  }

  const body = (
      <div style={paperStyle}>
        <div className="modal-header" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '16px' }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', fontFamily: "'Fira Sans', sans-serif" }}>
            {candidatName.split(" ")[0]} {candidatName.split(" ")[1]?.charAt(0)}.
          </Typography>
        </div>
        <div
            className="modal-body"
            style={{height: "500px", overflowY: "auto"}}
            ref={formRef}
        >
          <label className="input-label" htmlFor="de">
            De<span className="required-input">*</span>
          </label>
          {loadingUsers ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress/>
              </Box>
          ) : (
              <FormControl variant="outlined" fullWidth margin="normal">
                <InputLabel
                    {...(errors.de && {
                      error: true,
                    })}
                    shrink
                >
                  {errors.de}
                </InputLabel>
                <Select
                    value={de}
                    name="users"
                    onChange={(e) => {
                      handleSignature(e.target.value);
                    }}
                    {...(errors.de && {
                      error: true,
                    })}
                    input={
                      <OutlinedInput
                          name="de"
                          {...(errors.de && {
                            labelWidth: 280,
                          })}
                          notched
                      ></OutlinedInput>
                    }
                >
                  {loadingUsers ? (
                      <CircularProgress/>
                  ) : (
                      users.map((user) => (
                          <MenuItem value={user.uuid} key={user.uuid}>
                            {`${user.nom} ${user.prenom} (${user.email})`}
                          </MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
          )}
          <label className="input-label" htmlFor="cci">
            CC
          </label>
          <TagsInput
              selectedTags={handleSelectedCC}
              fullWidth
              id="cc"
              name="cc"
              validation={/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}
              placeholder="Ajouter des CC"
          />
          <FormControlLabel
              control={
                <Checkbox checked={checked === 1} onChange={handlecheckChange}/>
              }
              label="Ne pas envoyer ce mail (juste pour stats)"
          />{" "}
          <br/>
          <label className="input-label" htmlFor="cci">
            CCI
          </label>
          <TagsInput
              selectedTags={handleSelectedCCI}
              fullWidth
              variant="outlined"
              id="cci"
              name="cci"
              placeholder="Ajouter des CCI"
          />
          <label className="input-label" htmlFor="objet">
            OBJET<span className="required-input">*</span>
          </label>
          <TextField
              id="objet"
              value={objet}
              onChange={(e) => setObjet(e.target.value)}
              placeholder="OBJET..."
              margin="normal"
              variant="outlined"
              autoComplete="off"
              fullWidth
              {...(errors.objet && {
                error: true,
                label: errors.objet,
              })}
          />
          {forReveal ? (
              <PourMission/>
          ) : (
              <>
                <Box
                    sx={{display: "flex", flexDirection: "column"}}
                    style={{marginBottom: "1em"}}
                >
                  {listItem}
                </Box>
              </>
          )}
          <label className="input-label" htmlFor="message">
            MESSAGE
          </label>
          <EditorCustom {...editorCustomProps} />
          <div style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
            <Checkbox
                value="displayPhoneNumber"
                color="primary"
                id="displayPhoneNumber"
                checked={displayPhoneNumber}
                onChange={(e) => setDisplayPhoneNumber(e.target.checked)}
                style={{marginRight: "8px"}}
            />
            <label htmlFor="displayPhoneNumber" style={{fontSize: "16px", color: "#000", paddingTop: "5px"}}>
              Afficher mon numéro
            </label>
          </div>
        </div>
        {dataUpload.length > 0 && (
            <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  height: "100%",
                  overflow: "hidden",
                  maxWidth: "800px",
                  flexWrap: "wrap",
                  padding: "10px 0 0 0 "

                }}
                className="input-label"

            >
              <span>PJ:</span>
              {dataUpload.map((file, indexToRemove) =>
                  <Chip
                      key={v4()}
                      label={file.name}
                      variant="default"
                      onDelete={() => setDataUpload(prevData => prevData.filter((_, index) => index !== indexToRemove))}
                      size="small"
                  />
              )}

            </Box>
        )}
        {missingFormattedCv && (
            <Alert
                severity="warning"
                sx={{ mt: 1.5, borderRadius: '10px', alignItems: 'center' }}
                action={
                  <Button size="small" variant="contained" onClick={handleFormatCv} disabled={formattingCv}
                      startIcon={formattingCv ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}
                      sx={{ textTransform: 'none', fontWeight: 600, background: '#03407b', whiteSpace: 'nowrap', '&:hover': { background: '#02357a' } }}>
                    {formattingCv ? 'Génération…' : 'Générer le CV formaté'}
                  </Button>
                }
            >
              Ce candidat n'a pas de CV formaté (format Go&Dev), obligatoire pour l'envoi au client.
              {formattingCv && ' La génération par IA peut prendre jusqu’à 1 à 2 minutes.'}
            </Alert>
        )}
        <div className="modal-footer" style={{marginTop: "10px"}}>
          {!dataUpload.length > 0 && (
              <Box sx={{display: "flex"}}>
                <input
                    type="file"
                    onChange={(e) => setDataUpload(Array.from(e.target.files))}
                    style={{ display: "none" }}
                    ref={uploadRef}
                    multiple
                />
                <IconButton
                    // disabled={value.isMail || loading}
                    onClick={() => uploadRef.current.click()}
                    data-toggle="tooltip"
                    title="Ajouter PJ"
                >
                  <AttachFile style={{ fontSize: "20px" }} color="primary" />
                </IconButton>
              </Box>
          )}
          <Button
              sx={{ background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '10px', textTransform: 'none', fontWeight: 600, mr: 1, '&:hover': { background: '#e2e8f0' } }}
              onClick={handleClose}
              disabled={loading}
          >
            Annuler
          </Button>
          <Button
              startIcon={loading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : <FiSend />}
              sx={{ background: 'linear-gradient(135deg, #0556a4, #03407b)', color: '#fff', borderRadius: '10px', textTransform: 'none', fontWeight: 600, boxShadow: '0 2px 8px rgba(3,64,123,0.28)', '&:hover': { background: 'linear-gradient(135deg, #03407b, #022d68)' }, '&.Mui-disabled': { color: '#fff', opacity: 0.7 } }}
              onClick={handleSend}
              disabled={loading || loadingUsers || formattingCv}
          >
            {loading ? 'Envoi en cours…' : 'Envoyer'}
          </Button>

        </div>
      </div>

  );

  return (
      <>
        {isMissionActive && sentDate !== "" ? (
            <button
                className="btn btn-sm btn-link"
                style={disabled ? { textDecoration: "none", cursor: "text" } : { textDecoration: "none" }}
                onClick={handleOpen}
            >
              {revealDate ?? sentDate}
            </button>
        ) : (<>{revealDate ?? sentDate}</>)}
        <Modal
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            open={openModal}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
          <Fade in={openModal}>{body}</Fade>
        </Modal>
      </>
  );
}

export default withSnackbar(SendCandidatToClientModal);
